import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';

import type {
  AppDetailResponse,
  InstallFromSoftwareLibraryResponse,
  InstallableSoftwareDetailResponse,
  InstallableSoftwareQuery,
} from './type';

export async function getSuggestedSoftware() {
  const res = await apiClient.GET(
    '/v2/software-library/installable-software/suggest',
  );
  return getDataOrThrowApiError(res);
}

export async function getSoftwareCategories() {
  const res = await apiClient.GET(
    '/v2/software-library/installable-software/category',
  );
  return getDataOrThrowApiError(res);
}

export async function getInstallableSoftware(params: InstallableSoftwareQuery) {
  const res = await apiClient.GET('/v2/software-library/installable-software', {
    params: { query: params },
  });
  return getDataOrThrowApiError(res);
}

export async function getInstallableSoftwareDetail(
  softwareLibraryId: string,
): Promise<InstallableSoftwareDetailResponse> {
  const res = await apiClient.GET(
    '/v2/software-library/installable-software/{softwareLibraryId}',
    {
      params: { path: { softwareLibraryId } },
    },
  );
  return getDataOrThrowApiError(res);
}

export async function getAppDetail(appId: string): Promise<AppDetailResponse> {
  const res = await apiClient.GET('/v2/apps/{id}', {
    params: { path: { id: appId } },
  });
  return getDataOrThrowApiError(res);
}

export async function installFromSoftwareLibrary(
  softwareLibraryId: string,
): Promise<InstallFromSoftwareLibraryResponse> {
  const res = await apiClient.POST(
    '/v2/software/install-from-software-library',
    {
      body: { softwareLibraryId },
    },
  );
  return getDataOrThrowApiError(res);
}
